import { useEffect } from 'react';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { Box, PressableIcon } from '@bonanza-social/moonlight';
import {
  fetchPrizeWall,
  selectPrizeWallDataState,
} from '../../state/prizeWall/prizeWall.slice';
import { PrizeWallQuickRulesModalProps } from './PrizeWallQuickRulesModal.types';
import PrizeWallQuickRules from '../../components/PrizeWallQuickRules/PrizeWallQuickRules';
import PrizeWallQuickRulesBackground from '../../components/PrizeWallQuickRules/PrizeWallQuickRulesBackground/PrizeWallQuickRulesBackground';

function PrizeWallQuickRulesModal({ close }: PrizeWallQuickRulesModalProps) {
  const dispatch = useDispatch();
  const dataState = useSelector(selectPrizeWallDataState);
  const shouldGoBack = window.location.pathname !== '/promos';

  useEffect(() => {
    if (dataState === 'idle' || dataState === 'rejected') {
      dispatch(fetchPrizeWall());
    }
  }, [dataState, dispatch]);

  return (
    <Box flex={1} paddingTop="space-1800" paddingBottom="space-600">
      <PrizeWallQuickRulesBackground />
      <PrizeWallQuickRules shouldGoBack={shouldGoBack} />
      <PressableIcon
        name="close"
        width="space-600"
        height="space-600"
        position="absolute"
        top="space-600"
        right="space-600"
        gradient="accentBackground"
        testID="modal-header-close"
        onPress={close}
      />
    </Box>
  );
}

export default PrizeWallQuickRulesModal;
